import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ng2-cookies';
import { Base64Service } from '../base64/base64.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private count = 0;
    private redirectUrl = '/dashboard';
    private loginUrl = '/login' || '/';

    constructor(
        private router: Router,
        private base64Service: Base64Service,
        private cookieService: CookieService,
    ) { }

    setLoggedInUser(user_preference: any): void {
        user_preference = JSON.stringify(user_preference);
        const b64 = this.base64Service.encode(user_preference);
        this.setAuthPreference('__PAK', b64);
    }

    getLoggedInUser(): string {
        const b64 = this.getAuthPreference('__PAK');
        const loggedInUser = this.base64Service.decode(b64);
        return loggedInUser;
    }

    private setAuthPreference(key: any, value: any): any {
        return (typeof (Storage) !== 'undefined') ? key === 'authToken' ? localStorage.setItem(key, value) : sessionStorage.setItem(key, value) : this.cookieService.set(key, value);
    }

    private getAuthPreference(key: any) {
        if (typeof (Storage) !== 'undefined') {
            if (key === 'authToken') {
                return localStorage.getItem(key);
            } else {
                return sessionStorage.getItem(key);
            }
        } else {
            return
        }
    }

    getAuthorizationHeader(): any {
        if (this.getAuthPreference('authToken')) {
            return {
                'authorization': 'Bearer ' + this.getAuthPreference('authToken'),
                'device-token': this.getAuthPreference('authToken'),
                //'env_id': this.getAuthPreference('envID'),
            };
        }
        // if (this.getAuthPreference('passToken')) {
        //     return {
        //         'authorization': 'Bearer ' + this.getAuthPreference('passToken'),
        //         'device-token': this.getAuthPreference('passToken'),
        //         //'env_id': this.getAuthPreference('envID'),
        //     };
        // }
        return {};
    }







    getLoginUrl(): string {
        return this.loginUrl;
    }

    setCredential(key: string, value: string): void {
        this.setAuthPreference(key, value);
    }

    getCredential(key: string) {
        return this.getAuthPreference(key);
    }

    isUserLoggedIn(): boolean {
        return (this.getCredential('authToken')) ? true : false;
    }

    checkForceUpdate(): boolean {
        return (this.getCredential('force_update_pass')) ? true : false;
    }

    setRedirectUrl(url: string): void {
        this.redirectUrl = url;
    }

    getRedirectUrl(): string {
        return this.redirectUrl;
    }

    setCurrentRoute(route: string) {
        this.setCredential('active-route', route);
    }

    getCurrentRoute() {
        return this.getCredential('active-route');
    }


    setAuthInfo(response: any) {
        //this.setCredential('__EmailId', response.data.user_details.email);
        //this.setCredential('_UID', response.data.user_details.account_id);
        //this.setCredential('_UTYPE', response.data.user_details.user_type);
        //this.setCredential('userEnv', JSON.stringify(response.data.user_details.user_environments));
        //this.setCredential('userEnvFeature', JSON.stringify(response.data.user_details.user_env_features));
        this.setCredential('authToken', response.data.token);
        localStorage.setItem('userData', JSON.stringify(response.data?.user))
        //   this.setCurrentRoute('/dashboard');
        //this.setLoggedInUser(response.data.user_details);
        /* response.data.user_details.user_environments.forEach(element => {
          if (element.status == 'active') {
            this.setCredential('envID', element.env_id);
            this.setCredential('envName', element.env_name);
  
          }
        }); */
    }
    setAuthIfno(response: any) {
        this.setCredential('__EmailId', response.data.user_details.email);
        this.setCredential('_UID', response.data.user_details.account_id);
        this.setCredential('_UTYPE', response.data.user_details.user_type);
        this.setCredential('userEnv', JSON.stringify(response.data.user_details.user_environments));
        this.setCredential('userEnvFeature', JSON.stringify(response.data.user_details.user_env_features));
        this.setCredential('authToken', response.data.user_details.token);
        this.setCurrentRoute('/dashboard');
        this.setLoggedInUser(response.data.user_details);
        response.data.user_details.user_environments.forEach((element: any) => {
            if (element.status == 'active') {
                this.setCredential('envID', element.env_id);
                this.setCredential('envName', element.env_name);

            }
        });
    }

    logoutUser(status = true, redirectUrl?: string) {
        //   alert("sdfsd");
        if (typeof (Storage) !== 'undefined') {
            localStorage.clear();
            window.sessionStorage.clear();
            if (status) {
                sessionStorage.removeItem('active-route');
            }
        }
        if (this.getLoginUrl() === '/error') {
            this.redirectUrl = redirectUrl || '/dashboard';
            this.router.navigate([this.getLoginUrl()]);
        } else {
            window.location.href = this.getLoginUrl();
        }
    }
}
